import React from 'react';
import FooterLinks from './FooterLink';
import SocialMedia from './SocialMedia';
import { Divider } from '@mui/material';
import { convertEpochToDate } from '../../../../../../../../obps/src/utils';

const TCPFooter = () => {
    return (
        <div style={{display: 'flex', flexDirection: 'column', background: 'rgba(18, 42, 69, 1)', }}>
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                <FooterLinks />
                <SocialMedia />
                <Divider />
            </div>
            <p style={{ textAlign: 'center', color: '#fff', fontSize:'14px', letterSpacing: '2' }}>© 2024-25, Department of Town & Country Planning, Govt. of Uttar Pradesh | Powered By: <span style={{color: "rgb(204, 133, 0)", fontWeight: 'bold', fontSize: '16px'}}>ABM Knowledgeware Pvt Ltd.</span></p>
            <p style={{ textAlign: 'center', color: '#fff', fontSize:'14px' }}>Last Updated On : {convertEpochToDate(Date.now())}</p>
        </div>

    );
};

export default TCPFooter;
